module.exports = __webpack_public_path__ + "static/media/composition-right.1277e815.PNG";